<app-header extraClass="text-gray" displayNavigation="true" displayProductSwitch="true"
  [standardProduct]="product.details.product_type === 'STANDARD'?true:false"></app-header>

<div
  class="container {{product.details.product_type === 'STANDARD'?'standard-product':'exclusive-product'}} mt-130 container-1050"
  *ngIf="product">
  <div class="order-details-wrp">
    <div class="order-step-tabs">
      <ul uk-tab class="uk-child-width-expand tabs-link">
        <li id="order-summary">
          <a href="#">
            <span>STEP 1</span> <i><b class="hideMobile">Order</b> Summary</i>
          </a>
          <div class="icon"><img src="assets/images/icons/yellow-right.png" alt=""></div>
        </li>
        <li id="payment" class="uk-disabled">
          <a href="#">
            <span>STEP 2</span> <i>Payment</i>
          </a>
          <div class="icon"><img src="assets/images/icons/yellow-right.png" alt=""></div>
        </li>
        <li id="confirmation" class="uk-disabled">
          <a href="#">
            <span>STEP 3</span> <i>Confirmation</i>
          </a>
        </li>
      </ul>

      <div class="session-timer mt-2 mb-2">
        <span>Your experience is reserved for the next </span> <br />
        <b>
          <countdown #cd [config]="countDownConfig" (event)="handleCountDown($event)"></countdown>
        </b> minutes
      </div>

      <div class="offer-slider" uk-slider="sets: false; finite: true" *ngIf="offers">
        <div class="uk-slider-items uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m ">

          <div class="offer-item" uk-toggle="target: #modal-offer_{{offer.id}}" *ngFor="let offer of offers"
            (click)="openOffersModal(offer.id)">
            <div class="offer-flex">
              <div class="offer-flex-item">
                <img src="assets/images/offer.jpg">
              </div>
              <div class="offer-flex-item">
                <p class="offer-per">{{offer.title}}</p>
                <p class="offer-info">{{offer.short_description}}</p>
              </div>
            </div>
          </div>

        </div>
        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="javascript:;" uk-slidenav-previous
          uk-slider-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="javascript:;" uk-slidenav-next
          uk-slider-item="next"></a>
      </div>


      <ng-container *ngIf="offers">
        <div id="modal-offer_{{offer.id}}" uk-modal *ngFor="let offer of offers">
          <div class="uk-modal-dialog uk-margin-auto-vertical">

            <button class="uk-modal-close-default" type="button" uk-close></button>

            <div class="uk-modal-header">
              <h2 class="uk-modal-title">Offer Details</h2>
            </div>

            <div class="uk-modal-body" uk-overflow-auto>
              <img src="{{this.apiURL + '/img/'+offer.bank_logo}}" class="offer-logo">

              <p class="offer-per">{{offer.title}}</p>
              <p class="offer-info">{{offer.short_description}}</p>
              <p class="offer-validity">Valid till: {{offer.valid_till}} </p>

              <hr />
              <p class="terms-heading">Terms and Conditions</p>

              <ul>
                <li [innerHTML]="offer.terms_of_conditions"></li>
              </ul>
            </div>


          </div>
        </div>
      </ng-container>

      <ul class="uk-switcher">

        <!--STEP 1-->
        <li class="ordersummary-wrp mb-6">

          <div class="order-details-wrp uk-flex uk-flex-wrap">

            <div class="w-40">
              <div class="details-card">
                <div class="image">
                  <img src="{{product.details.featured_image}}" alt="{{product.details.title}}">
                </div>

                <div class="sharing-card-wrp">
                  <h5 class="uk-flex uk-flex-middle">
                    <!--<img
src="assets/images/icons/location-black.png"
alt="">-->
                    <i class="fa fa-map-marker"></i>&nbsp; {{product.details.sub_locality ?
                    product.details.sub_locality : product.details.city}}
                  </h5>
                  <h4>{{product.details.title}}</h4>
                  <div class="uk-flex uk-flex-middle">
                    <span>{{product.details.category_name}}</span>
                    <div class="position-relative">
                      <i class="fa fa-share-alt cursor-pointer opensharelink sharing-link"
                        (click)="openShareLink()"></i>&nbsp;&nbsp;
                      <div class="sharelink uk-flex">
                        <share-buttons [theme]="'default'"
                          [include]="['facebook','twitter','telegram','whatsapp','sms','email']" [show]="9" [size]="1"
                          [url]="pageURL" [image]="pageFeaturedImage" [autoSetMeta]="false"></share-buttons>
                      </div>
                    </div>
                    <app-wishlist [productData]=product></app-wishlist>
                  </div>
                </div>
                <!--sharing-card-wrp-->

                <ng-container *ngIf="product.details.product_type === 'EXPERIENCE'">
                  <!--- 27 sep VIP-->

                  <!--- 27 sep VIP-->

                  <div class="date-and-time-wrp uk-flex uk-flex-middle uk-flex-between"
                    style="{{product.details.product_type === 'STANDARD'?'visibility:hidden':''}}"
                    *ngIf="appService.isDesktopDevice && productEventsAvailable">
                    <div class="dt-card">
                      <h4>Date and Time</h4>
                      <input type="date" class="date uk-input position-relative" placeholder="MM/DD/YYYY"
                        onfocus="(this.type='date')" onblur="(this.type='date')" value="{{productSchedule.date}}"
                        max="{{maxDate | date:'yyyy-MM-dd'}}" (change)="fillTime($event.target)">
                      <!--<mat-form-field class="example-full-width" appearance="fill" *ngIf="dateFilter">
  <mat-label>Choose a date</mat-label>
  <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="picker" name="occasion_date"
         required="required" max="2022-08-01" [(ngModel)]="productSchedule.date"
         min="{{minDate | date:'yyyy-MM-dd'}}"
         (dateChange)="fillTime($event.target)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field> -->

                      <div class="uk-form-controls">
                        <select class="uk-select" name="time_slot" [(ngModel)]="productSchedule.time"
                          (change)="fillGuests()"
                          disabled="{{latestProductSchedule[productSchedule.date] && latestProductSchedule[productSchedule.date].length === 0?'true':''}}">

                          <ng-container *ngIf="productSchedule.date">
                            <option value="{{time.time_from}}-{{time.time_to}}"
                              *ngFor="let time of latestProductSchedule[productSchedule.date]">
                              {{(time.time_from == '0:00' || time.time_from == '00:00') ?
                              'Subject to Availability' : time.time_from + '-' +
                              time.time_to}}
                            </option>
                          </ng-container>

                        </select>
                      </div>
                    </div>
                    <div class="info position-relative">

                      <!--- 27 sep VIP-->
                      <!-- <a href="" class="edit-btn">Edit</a> -->
                      <!--- 27 sep VIP-->

                      <p>Select People</p>
                      <div class="select-people-drop mt-1">
                        <select class="uk-select" name="number_of_guest" [(ngModel)]="productSchedule.ppl"
                          (change)="setPrice()">
                          <option value="0">Please select</option>
                          <ng-container *ngIf="productSchedule.date">
                            <ng-container *ngFor="let time of NoOfGuests">
                              <option value="{{time}}">
                                {{time}}
                              </option>
                            </ng-container>
                          </ng-container>

                        </select>
                      </div>
                      <!-- <div class="quantity mt-1">
    <button class="minus-btn btn  disabled" type="button">-</button>
    <input id="quantity" type="text" value="1" readonly>
    <button class="btn plus-btn" type="button">+</button>
</div> -->
                    </div>
                  </div>
                  <div class="" uk-sticky="offset: 100;bottom: true"
                    *ngIf="productEventsAvailable && appService.isMobile">
                    <form #enquiryForm="ngForm" method="post">

                      <div class="guest-card uk-flex uk-flex-middle datepicker">
                        <div class="icon fa-icon1">
                          <!--<img src="assets/images/icons/calendar-2.png" alt="">-->
                          <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                        </div>
                        <div class="info ">
                          <h4>Date</h4>

                          <input class="uk-input" placeholder="Select Date" type="date" name="occasion_date"
                            required="required" max="2022-08-01" [(ngModel)]="productSchedule.date"
                            #enquiryOccasionDate="ngModel" (change)="fillTime($event.target)"
                            min="{{minDate | date:'yyyy-MM-dd'}}" max="{{maxDate | date:'yyyy-MM-dd'}}">
                          <!--<mat-form-field class="example-full-width" appearance="fill" *ngIf="dateFilter">
  <mat-label>Choose a date</mat-label>
  <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="picker"
         name="occasion_date"
         required="required" max="2022-08-01" [(ngModel)]="productSchedule.date"
         min="{{minDate | date:'yyyy-MM-dd'}}"
         (dateChange)="fillTime($event.target)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>-->
                        </div>
                      </div>

                      <div class="guest-card uk-flex uk-flex-middle mt-1">
                        <div class="icon fa-icon2">
                          <!-- <img src="assets/images/icons/people-2.PNG" alt="">-->
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <div class="info">
                          <h4>Time Slot</h4>
                          <div uk-form-custom="target: > * > span:first-child">
                            <select class="uk-select" name="time_slot" [(ngModel)]="productSchedule.time"
                              (change)="fillGuests($event.target)" *ngIf="productSchedule.date"
                              disabled="{{ latestProductSchedule[productSchedule.date]&& latestProductSchedule[productSchedule.date].length === 1?'true':'false'}}">

                              <option value="0"> Select Time Slot</option>
                              <ng-container *ngFor="let time of latestProductSchedule[productSchedule.date]">
                                <option value="{{time.time_from}}-{{time.time_to}}">
                                  {{(time.time_from !== '0:00' && time.time_from !=
                                  '00:00') ? time.time_from + '-' + time.time_to :
                                  'Subject to Availability'}}
                                </option>
                              </ng-container>

                            </select>
                            <button type="button" tabindex="-1">
                              <span></span>
                              <!--<img src="assets/images/icons/arrow-bottom-2.png" alt="">-->
                              <i aria-hidden="true" class="fa fa-angle-down f23"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="guest-card uk-flex uk-flex-middle mt-1">
                        <div class="icon fa-icon3">
                          <!--<img src="assets/images/icons/people-2.PNG" alt="">-->
                          <i class="fa fa-users" aria-hidden="true"></i>
                        </div>
                        <div class="info">
                          <h4>Guests</h4>
                          <div uk-form-custom="target: > * > span:first-child">
                            <select class="uk-select" name="number_of_guest" [(ngModel)]="productSchedule.ppl"
                              (change)="setPrice()" disabled="{{NoOfGuests.length === 1?'true':'false'}}">

                              <option selected value="0">Please select</option>
                              <ng-container *ngIf="productSchedule.date">
                                <ng-container *ngFor="let time of NoOfGuests">
                                  <option value="{{time}}">
                                    {{time}}
                                  </option>
                                </ng-container>
                              </ng-container>

                            </select>
                            <button type="button" tabindex="-1">
                              <span></span>
                              <!--<img src="assets/images/icons/arrow-bottom-2.png" alt="">-->
                              <i aria-hidden="true" class="fa fa-angle-down f23"></i>
                            </button>
                          </div>
                        </div>

                      </div>
                      <ng-container *ngIf="!isAvailabilityPresent">
                        <p class="error">Sold Out! Select another date</p>
                      </ng-container>
                      <!--guest-card-->


                      <!--guest-card-->

                      <div class="details mt-3 text-center" *ngIf="responseReceived">
                        <h4><i class="fa fa-rupee"></i> {{calculatedPrice ? calculatedPrice :
                          product.details.sale_price}}
                        </h4>
                        <ng-container *ngIf="enquiryPayLoad.number_of_guest">
                          <p>Inclusives taxes for {{enquiryPayLoad.number_of_guest}} people
                          </p>
                        </ng-container>


                        <button type="submit" class="btn-yellow btn-full mt-3" (click)="addToCart()"
                          [disabled]="product.details.product_type == 'EXPERIENCE' && !isAvailabilityPresent">
                          Buy Now
                        </button>
                        <span>Valid through 31st December, 2021</span>
                      </div>

                      <span class="error uk-text-center" *ngIf="enquiryErrorMessage">
                        {{this.enquiryErrorMessage}}
                      </span>

                    </form>

                  </div>
                </ng-container>

              </div>
            </div>
            <!--w-35--->

            <div class="w-60">

              <div class="order-summery uk-flex uk-flex-bottom uk-flex-wrap">

                <div class="order-summery-card">
                  <h5>Price Details</h5>

                  <!-- Premium Product -->
                  <div class="uk-flex order-price" *ngIf="product.details.product_type === 'EXPERIENCE'">
                    <p class="w-50">1x {{product.details.title}} for {{productSchedule.ppl}} people
                    </p>
                    <h4 class="hidelg w-50">
                      <i class="fa fa-rupee"></i> {{calculatedPrice ? calculatedPrice :
                      product.details.sale_price | currency:'INR':'':'1.0-0'}}
                    </h4>
                  </div>

                  <!-- Standard Product -->
                  <div class="uk-flex order-price" *ngIf="product.details.product_type === 'STANDARD'">
                    <p class="w-50">{{productDeal.quantity}}x {{productDeal.deal_title}} for
                      {{productDeal.deal_valid_for}}</p>
                    <h4 class="hidelg w-50"><i class="fa fa-rupee"></i>{{productDeal.deal_sale_price|
                      currency:'INR':'':'1.0-0'}}</h4>
                  </div>

                  <div class="number" *ngIf="product.details.product_type === 'STANDARD'">
                    <div class="number">
                      <span class="minus" (click)="decreaseQty(productDeal)">-</span>
                      <input type="text" class="quantity-input" disabled value="1" [(ngModel)]="productDeal.quantity" />
                      <span class="plus" (click)="increaseQty(productDeal)">+</span>
                    </div>
                  </div>

                  <!-- Coupon Code -->
                  <div class="discount-code uk-flex" *ngIf="product.details.product_type == 'STANDARD'">
                    <div class="code-field position-relative">
                      <label>Have a discount code?</label>
                      <input class="uk-input" type="text" placeholder="Enter Coupon" [(ngModel)]="couponCode"
                        name="couponCode">
                      <img src="assets/images/icons/right-green-2.png" alt="" class="redclose cursor-pointer"
                        *ngIf="promoCodeApplied">
                    </div>
                    <a class="code-apply" *ngIf="promoCodeApplied" (click)="removeCoupon()">Remove</a>
                    <a class="code-apply" *ngIf="!promoCodeApplied" (click)="applyCoupon()">Apply</a>
                  </div>
                  <div class="discount-code uk-flex" *ngIf="product.details.product_type == 'EXPERIENCE'">
                    <div class="position-relative">
                      <label>Have a promo code or voucher?</label>
                      <input class="uk-input" type="text" placeholder="Enter Voucher" [(ngModel)]="couponCode"
                        oninput="this.value = this.value.toUpperCase()" name="couponCode">
                      <img src="assets/images/icons/right-green-2.png" alt="" class="redclose cursor-pointer"
                        *ngIf="promoCodeApplied">
                    </div>
                    <a class="code-apply" *ngIf="promoCodeApplied" (click)="removeTicketXpressVoucher()">Remove</a>
                    <a class="code-apply" *ngIf="!promoCodeApplied" (click)="applyTicketXpressVoucher()"
                      style="width: 155px;"> Apply <i class="fa fa-spinner fa-spin" *ngIf="applyVoucherLoader"></i> </a>


                  </div>
                  <span class="error" *ngIf="promoError">
                    {{promoError}}
                  </span>


                </div>

                <!-- Premium Product -->
                <div class="order-details code-applied">
                  <!-- STANDARD PRODUCT -->

                  <ng-container *ngIf="product.details.product_type == 'STANDARD'">
                    <h4 class="hideMobile">
                      <i class="fa fa-rupee"></i> {{productDeal.deal_sale_price|
                      currency:'INR':'':'1.0-0'}}
                    </h4>
                    <div class="promo-code-applied" *ngIf="promoCodeApplied">
                      <h6>Promo code applied</h6>
                      <span>- <i class="fa fa-rupee"></i> {{ couponResponse.old_price -
                        (couponResponse.new_price > 0 ? couponResponse.new_price :0) | currency:'INR':'':'1.0-0'}}</span>
                    </div>
                  </ng-container>


                  <!-- EXCLUSIVE PRODUCT -->
                  <ng-container *ngIf="product.details.product_type == 'EXPERIENCE'">
                    <h4 class="hideMobile">
                      <i class="fa fa-rupee"></i> {{productSchedule.event_price|
                      currency:'INR':'':'1.0-0'}}
                    </h4>
                    <div class="promo-code-applied" *ngIf="promoCodeApplied">
                      <h6>Promo code applied</h6>
                      <span *ngIf="couponCode.slice(0,4) == 'T2DE'">- <i class="fa fa-rupee"></i> {{ couponResponse.old_price -
                        (couponResponse.new_price > 0 ? couponResponse.new_price :0) | currency:'INR':'':'1.0-0'}}</span>
                      <span *ngIf="couponCode.slice(0,4) != 'T2DE'">- <i class="fa fa-rupee"></i> {{ticketXpressRemainingValue |
                        currency:'INR':'':'1.0-0'}}</span>
                    </div>
                  </ng-container>

                </div>
                <div class="total-amount uk-flex uk-flex-between uk-flex-middle w-100 convenienceFee"
                  *ngIf="product.details.convenience > 0 || productDeal?.deal_convenience_fee > 0">
                  <p>+ Convenience Fee</p>
                  <h4><i class="fa fa-rupee"></i>

                    <ng-container *ngIf="product.details.product_type === 'STANDARD'">
                      <ng-container *ngIf="couponResponse?.old_price">
                        {{(((calculatedPrice ? calculatedPrice : productDeal.deal_sale_price) *
                        productDeal.quantity) - (couponResponse?.old_price -
                        couponResponse?.new_price)) * productDeal.deal_convenience_fee / 100 |
                        currency:'INR':'':'1.0-0' }}
                      </ng-container>

                      <ng-container *ngIf="!couponResponse?.old_price">
                        {{(((calculatedPrice ? calculatedPrice : productDeal.deal_sale_price) *
                        productDeal.quantity) - (couponResponse?.old_price -
                        couponResponse?.new_price)) * productDeal.deal_convenience_fee / 100 |
                        currency:'INR':'':'1.0-0' }}
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="product.details.product_type === 'EXPERIENCE'">
                      <ng-container *ngIf="couponResponse?.remaining_value">
                        {{(((calculatedPrice ? calculatedPrice : productSchedule.event_price) *
                        1)) * product.details.convenience / 100 | currency:'INR':'':'1.0-0' }}
                      </ng-container>

                      <ng-container *ngIf="!couponResponse?.remaining_value">
                        {{(((calculatedPrice ? calculatedPrice : productSchedule.event_price) *
                        1)) * product.details.convenience / 100 | currency:'INR':'':'1.0-0' }}
                      </ng-container>
                    </ng-container>

                  </h4>
                </div>
                <!--Loyalty Comment | Loyalty Amount deduction starts here-->
                <div *ngIf="redeemPointsSuccess"
                  class="loyalty-amount total-amount uk-flex uk-flex-between uk-flex-middle w-100 convenienceFee payingViaRewards">
                  <p>- Paying via Zillion Rewards</p>
                  <h4><i class="fa fa-rupee"></i> {{block_loy_points_amount}}
                  </h4>
                </div>
                <!--till here-->




                <ng-container *ngIf="!promoCodeApplied">
                  <div
                    class="total-amount total-amount-balance uk-flex uk-flex-between uk-flex-middle w-100 totalAmount"
                    *ngIf="product.details.product_type !== 'STANDARD'">
                    <p>Total (INR)</p>
                    <h4>
                      <i class="fa fa-rupee"></i>{{(calculatedPrice ? calculatedPrice :
                      product.details.sale_price) + (calculatedPrice ? calculatedPrice :
                      product.details.sale_price) * (product.details.convenience / 100) - (block_loy_points_amount > 0 ? block_loy_points_amount : 0) |
                      currency:'INR':'':'1.0-0'
                      }}
                    </h4>
                  </div>

                  <div class="total-amount total-amount-balance uk-flex uk-flex-between uk-flex-middle w-100"
                    *ngIf="product.details.product_type === 'STANDARD'">
                    <p>Total (INR)</p>
                    <h4><i class="fa fa-rupee"></i> {{((productDeal.deal_sale_price *
                      productDeal.quantity) + ((productDeal.deal_sale_price *
                      productDeal.quantity)) * (productDeal.deal_convenience_fee / 100)
                       - (block_loy_points_amount > 0 ? block_loy_points_amount : 0) ) |
                      currency:'INR':'':'1.0-0'}}
                    </h4>
                  </div>
                </ng-container>

                <ng-container *ngIf="couponResponse">
                  <div class="total-amount total-amount-balance uk-flex uk-flex-between uk-flex-middle w-100"
                    *ngIf="product.details.product_type !== 'STANDARD'">
                    <p>Total (INR)</p>
                    <h4>
                      <i class="fa fa-rupee"></i> {{calculatedPrice -
                      (ticketXpressRemainingValue) + ((calculatedPrice ?
                      calculatedPrice : product.details.sale_price) * product.details.convenience
                      / 100) > 0 ? (calculatedPrice -
                      (ticketXpressRemainingValue) + ((calculatedPrice ?
                      calculatedPrice : product.details.sale_price) * (product.details.convenience
                      / 100) - (block_loy_points_amount > 0 ? block_loy_points_amount : 0)) | number: '1.0-0') : 0 | currency:'INR':'':'1.0-0' }}
                    </h4>
                  </div>

                  <div class="total-amount total-amount-balance uk-flex uk-flex-between uk-flex-middle w-100"
                    *ngIf="product.details.product_type === 'STANDARD'">
                    <p>Total (INR)</p>
                    <h4><i class="fa fa-rupee"></i> {{((productDeal.deal_sale_price *
                      productDeal.quantity) - (couponResponse?.old_price -
                      couponResponse?.new_price)) + ((productDeal.deal_sale_price *
                      productDeal.quantity) - (couponResponse?.old_price
                      - couponResponse?.new_price)) * (productDeal.deal_convenience_fee / 100) - (block_loy_points_amount > 0 ? block_loy_points_amount : 0) |
                      currency:'INR':'':'1.0-0'}}
                    </h4>
                  </div>

                </ng-container>

              </div>

              <div class="order-details-profile mt-2">
                <p>Your Details</p>
                <div class="profile-icon">
                  <!-- <img src="" alt=""> -->
                </div>

                <div class="btn-box mt-15 uk-flex uk-flex-center" *ngIf="currentUser">
                  <a class="profile-link-btn">
                    <!--<img src="assets/images/icons/call.png" alt="">-->
                    <i class="fa fa-phone"></i>&nbsp; {{currentUser.mobile_number}}
                  </a>
                  <a class="profile-link-btn" *ngIf="currentUser.email">
                    <!--<img src="assets/images/icons/mail.png" alt="">-->
                    <i class="fa fa-envelope"></i>&nbsp; {{currentUser.email || 'abc@example.com'}}
                  </a>
                </div>
              </div>

            </div>
            <!--65--->

          </div>




          <!--Loyalty Comment |  link and popup-->
          <div class="loyal-link w-40 mt-2 mb-2" (click)="clearPaybackPointData()"
            *ngIf="!redeemPointsSuccess && !currentUser" id="payback_login_text">
            <img src="assets/images/zillionrewards2.png" alt="click here" loading="lazy">
            Login & Pay via Zillion Coins
          </div>
          <div class="loyal-link w-40 mt-2 mb-2" (click)="clearPaybackPointData()"
            *ngIf="!redeemPointsSuccess && currentUser" id="payback_login_text">
            <img src="assets/images/zillionrewards2.png" alt="click here" loading="lazy">
            Pay via Zillion Coins
          </div>
          <div class="loyal-link-rewards w-40 mt-2 mb-2" (click)="removePaybackPoint()" *ngIf="redeemPointsSuccess">
            <img src="assets/images/zillionrewards2.png" alt="click here" loading="lazy"> Paying via Zillion Coins
            <span class="loyal-link-rewards-close">&times;</span>
          </div>

          <div id="modal-loyal-points" uk-modal>
            <div class="uk-modal-dialog uk-margin-auto-vertical">

              <button class="uk-modal-close-default" type="button" uk-close></button>

              <div class="uk-modal-header">
                <h2 class="uk-modal-title">Pay Via Zillion Coins</h2>
              </div>

              <div class="uk-modal-body" uk-overflow-auto>
                <div class="account-details-screen">
                  <div class="text-center">
                    <img src="assets/images/zillionrewards1.png">
                    <p class="points-details">You can now redeem your Zillion Coins against <br />
                      any purchase on Things2do</p>
                  </div>

                  <!--Hide this block when subitted and show the hidden redeem-block-->
                  <div class="points-form">
                    <form #checkBalanceForm="ngForm" method="post">
                      <div class="form-group">
                        <input name="mobilenumber" id="mobilenumber" type="text" minlength="10"
                          [(ngModel)]="checkBalancePayLoad.mobilenumber" size="10" required="required" maxlength="10"
                          class="uk-input" placeholder="Mobile Number"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '')">
                        <span class="error" *ngIf="checkBalanceAccountError">{{checkBalanceAccountError}}</span>
                      </div>
                      <!-- <div class="form-group">
                        <input name="pin" id="pin" type="tel" required="" minlength="4" maxlength="4"
                        [(ngModel)]="checkBalancePayLoad.PIN" class="uk-input" placeholder="PIN">
                        <span class="error" *ngIf="checkBalancePinError">{{checkBalancePinError}}</span>
                      </div> -->

                      <div class="form-group text-center" *ngIf="!checkBalanceSuccessful">
                        <button type="submit" class="btn-yellow" (click)="checkBalance()"
                          [disabled]="checkBalancePayLoad.mobilenumber.length == 10 ? false: true">Check
                          Balance</button>
                        <!-- <small *ngIf="checkBalanceResponseReceived">{{checkBalanceResponseReceived}}</small> -->
                      </div>

                    </form>
                  </div>
                  <!--till here-->


                  <!--hide the above block when submitted and show the below section-->
                  <div class="redeem-block" *ngIf="checkBalanceSuccessful">
                    <div class="redeem-info">
                      <p>Available Balance<span> ₹ {{GetAccountBalance.AvailablePointsAmount}}</span></p>
                      <!-- <p>Total Points: <span>{{GetAccountBalance.TotalPointsPoint}} </span></p> -->
                      <p>Total Coins Available: <span>{{GetAccountBalance.AvailablePointsPoint}}</span></p>
                      <!-- <p>Valid till: <span>{{GetAccountBalance.NextExpiryDate}}</span></p> -->
                    </div>
                    <div class="redeem-point-edit position-relative">
                      <div class="form-group">
                        <label for="">Enter Amount to be used</label>
                        <input value="{{loy_points_amount}}" type="text" name="used_loy_points" id="used_loy_points"
                          class="form-input" oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                          (input)="changeLoyAmount($event.target.value)" [disabled]="disableinput" />
                        <span (click)="disableinput = !disableinput">Edit</span>
                      </div>
                      <span class="error" *ngIf="useLoyPointsError">{{useLoyPointsError}}</span>
                    </div>
                    <div class="total-saving"><i class="fa fa-info"></i> Total Redeemable Amount <span>₹
                        {{loy_points_amount}}</span></div>
                    <div class="form-group text-center">
                      <button type="submit" (click)="submitRedeemPoints()" class="btn-yellow">Redeem Coins</button>
                    </div>
                  </div>
                  <!--till here-->

                  <!--Verify OTP-->
                  <!-- <div class="verify-redeem-block" *ngIf="submitRedeemPointsSuccessful">
                    <div class="form-group">
                      <input name="verify_redeem_otp" id="verify_redeem_otp" type="tel" required="" minlength="6"
                        maxlength="6" oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        [(ngModel)]="checkBalancePayLoad.verify_redeem_otp" class="uk-input" placeholder="PIN">
                      <span class="error" *ngIf="checkBalanceOTPError">{{checkBalanceOTPError}}</span>
                    </div>
                    <div class="form-group text-center">
                      <button type="submit" (click)="verifyOTPForRedeemPoints()" class="btn-yellow">Verify</button>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- link and popup ends here-->

          <div id="modal-block-points-redemption" uk-modal>
            <div class="uk-modal-dialog uk-margin-auto-vertical">

              <button class="uk-modal-close-default" type="button" uk-close></button>

              <div class="uk-modal-header">
                <h2 class="uk-modal-title">OTP Verification For Pay Via Loyalty Coins</h2>
              </div>

              <div class="uk-modal-body" uk-overflow-auto>
                <div class="otp-wrp">

                  <div class="popup-logo mt-1 mb-2 uk-flex uk-flex-center">
                    <img src="assets/images/zillionrewards1.png" alt="">
                  </div>

                  <div class="info">
                    <p>OTP for verification for redeem Zillion Coin <br />
                      any purchase on Things2do</p>
                  </div>

                  <!--OTP POPUP-->

                  <div class="points-form">
                    <!-- <form #checkBalanceForm="ngForm" method="post"> -->
                    <div class="form-group">
                      <input name="verify_redeem_otp" id="verify_redeem_otp" type="tel" required="" minlength="6"
                        maxlength="6" [(ngModel)]="checkBalancePayLoad.verify_redeem_otp" class="uk-input"
                        placeholder="OTP">
                      <span class="error" *ngIf="checkBalanceOTPError">{{checkBalanceOTPError}}</span>
                    </div>
                    <div class="form-group text-center">
                      <button type="submit" (click)="verifyOtpForRedeemPoints()" class="btn-yellow">Verify</button>
                    </div>
                    <!-- </form> -->
                  </div>


                  <div class="info" style="margin-top: 10px;">
                    <h6>Didn’t recieve the code? Request again</h6>
                    <a (click)="resendOTPPayback()">Resend OTP <i class="fa fa-spinner fa-spin"
                        *ngIf="resendOTPPaybackInProgress" style="margin-left: 10px;"></i></a>
                    <p *ngIf="receivedResentOTPPaybackResponse">OTP have been sent!</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div id="modal-buy-now-after-verify" uk-modal>
            <div class="uk-modal-dialog uk-margin-auto-vertical">

              <button class="uk-modal-close-default" type="button" uk-close></button>

              <div class="uk-modal-header">
                <h2 class="uk-modal-title">Buy Now</h2>
              </div>

              <div class="uk-modal-body" uk-overflow-auto>
                <div class="otp-wrp">

                  <div class="info">
                    <p>Zillion Points redemption successful. Please click on Buy Now to complete the transaction.</p>
                  </div>

                  <!--OTP POPUP-->

                  <div class="points-form">

                    <div class="form-group text-center">
                      <button type="submit" (click)="addToCartPayback()" class="btn-yellow">Buy Now</button>
                      <i class="fa fa-spinner fa-spin" *ngIf="paymentInProcess"></i>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <!--Block-->
          <!-- Loyalty Comment |  Earn loyalty points checkbox section starts here-->
          <!-- <div class="mt-2 mb-2 earn-checkbox">
            <label>
              <input type="checkbox" name="earnLoyalty" id="earnLoyalty" (click)="toggleShow()"
                [attr.checked]="i === 0 ? '' : null"> Earn Loyalty Points
              <span class="checkmark"></span> </label>
          </div> -->
          <div class="earn-box">
            <div class="payback-img"><img src="assets/images/zillionrewards1.png" alt="zillionrewards" loading="lazy"></div>
            <div class="earn-form">
              <form #checkEarnLoyaltyForm="ngForm" method="post">
                <div class="form-group">
                  <input name="earn_mobile_number" id="earn_mobile_number" type="text" minlength="10" value="1"
                    [(ngModel)]="earnLoyaltyPayLoad.earn_mobile_number" size="10" required="required" maxlength="10"
                    class="uk-input" placeholder="Mobile Number" (focusout)="earnLoyaltyCheck()"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '')" class="uk-input"
                    placeholder="Mobile Number">
                  <span class="error" *ngIf="earnLoyaltyAccountError">
                    {{ earnLoyaltyAccountError }}
                  </span>
                  <span class="error" *ngIf="earnLoyaltyMobileError">
                    <strong>Account not found </strong> <br>This transaction is ineligible for earning coins as your
                    number is not registered with Zillion
                  </span>
                  <!-- <input type="submit" class="check-btn" Value="Check" (click)="earnLoyaltyCheck()"> -->
                </div>
              </form>

            </div>

            <!--Show after form submitted-->
            <div class="total-saving" *ngIf="EligiblePaybackAmount > 0"><i class="fa fa-info"></i> Eligible Zillion coins for this transaction - {{EligiblePaybackAmount}} Coins</div>
            <!---->
            <!-- <div class="signup-label mb-1" *ngIf="EligiblePaybackAmount == 0">
              <p>
                New to PAYBACK?<a href="#payback-account" uk-toggle> Sign up</a>
              </p>
            </div> -->

            <div class="earn-note">
              <b>Please Note : </b>
              <ol>
                <li>
                  Conversion Rate is 1 Re is equal to 4 coins
                </li>
                <li>
                  Post your transaction, your loyalty coins will be
                  added to your Zillion account after redemption.
                </li>
              </ol>

            </div>
          </div>

          <!--Earn loyalty points ends here-->




          <div class="ordersummary-other-details mt-2">

            <!--            <p>By selecting the button below, I agree to the Host's House Rules, things2do COVID-19 Safety-->
            <!--              Requirements and the Guest Refund Policy. I agree to pay the total amount shown if the Host-->
            <!--              accepts my booking request.</p>-->

            <ng-container *ngIf="!currentUser">
              <div class="floating-btn mt-4">
                <button type="submit" class="btn-yellow " (click)="showLoginForm()"
                  [disabled]="product.details.product_type == 'EXPERIENCE' && !isAvailabilityPresent">
                  <i class="fa fa-spinner fa-spin" *ngIf="paymentInProcess"></i>
                  Login & Buy Now
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="currentUser">
              <div class="floating-btn mt-4">
                <button type="submit" class="btn-yellow" *ngIf="loy_points_amount > 0" (click)="addToCartPayback()"
                  [disabled]="product.details.product_type == 'EXPERIENCE' && !isAvailabilityPresent">
                  <i class="fa fa-spinner fa-spin" *ngIf="paymentInProcess"></i>
                  Buy Now
                </button>
                <button type="submit" class="btn-yellow" *ngIf="loy_points_amount == 0" (click)="addToCart(true)"
                  [disabled]="product.details.product_type == 'EXPERIENCE' && !isAvailabilityPresent">
                  <i class="fa fa-spinner fa-spin" *ngIf="paymentInProcess"></i>
                  Buy Now
                </button>
              </div>
            </ng-container>


            <span class="error" *ngIf="checkoutError">
              {{checkoutError}}
            </span>

            <div class="cancel-policy mt-5">
              <h6>Cancellation Policy</h6>
              <p>For a full refund, cancel at least 14 days in advance of the start date of the
                experience.
                <a [routerLink]="['/terms-and-conditions']" class="text-green">Learn more about
                  cancellations</a>
              </p>
            </div>
          </div>

        </li>

        <!--STEP 2-->
        <li>
          &nbsp;
        </li>

        <!--STEP 3-->
        <li></li>


      </ul>
    </div>
  </div>

  <li class="confirmation-wrp mt-4 hide ">
    <div class="highlight-point text-center">
      <img src="assets/images/icons/cap.png" alt="" class="mb-2">
      <h4>Volia! Your Experience is confirmed</h4>
      <p>You will be hearing from us soon., we have sent the details on the registered contact details.
      </p>
    </div>

    <div class="cashback mt-3 uk-flex uk-flex-middle"
      *ngIf="isOrderPaymentDetailsReceived && orderPaymentResponse.coupons.length > 0">
      <span class="cashback-icon">
        <img src="assets/images/icons/cashback.png" alt="" border="0" />
      </span>
      <ng-container *ngIf="orderPaymentResponse.coupons.length === 2">
        Congrats! You're now eligible for cashback of Rs 800/- we have sent you the details on your registered
        email
      </ng-container>

      <ng-container *ngIf="orderPaymentResponse.coupons.length === 3">
        Congrats! You're now eligible for cashback of Rs 1400/- we have sent you the details on your registered
        email
      </ng-container>
    </div>

    <div class="order-details-wrp uk-flex uk-flex-wrap mt-4" *ngIf="isOrderPaymentDetailsReceived">


      <div class="w-40">
        <div class="details-card">
          <h6 class="uk-flex uk-flex-middle">
            <img src="assets/images/icons/yellow-right.png" alt=""> Your Experience Details
          </h6>
          <div class="image mt-2">
            <img src="{{orderPaymentResponse.product.featured_image}}"
              alt="{{orderPaymentResponse.product.product_title}}">
          </div>

          <div class="sharing-card-wrp">
            <h5 class="uk-flex uk-flex-middle">
              <!--<img
src="assets/images/icons/location-black.png" alt="">-->
              <i class="fa fa-map-marker"></i>&nbsp; {{orderPaymentResponse.product.city}}
            </h5>
            <h4>{{orderPaymentResponse.product.product_title}}</h4>
            <div class="uk-flex uk-flex-middle">
              <span>{{orderPaymentResponse.product.category_name}}</span>
              <div class="position-relative">
                <app-sharing [PageURL]="" [PageFeaturedImage]=""></app-sharing>
              </div>
              <app-wishlist [productData]=product></app-wishlist>
            </div>
          </div>
          <!--sharing-card-wrp-->

          <div class="date-and-time-wrp uk-flex uk-flex-middle uk-flex-between"
            style="{{product.details.product_type === 'STANDARD'?'visibility:hidden':''}}">
            <div class="dt-card">
              <h4>Date and Time</h4>
              <p>{{orderPaymentResponse.orders_meta.event_date}}</p>
              <span>{{orderPaymentResponse.orders_meta.time_from}}
                - {{orderPaymentResponse.orders_meta.time_to}}</span>
            </div>
            <div class="info position-relative">
              <p>People</p>
              <div class="select-people-drop mt-1">
                {{orderPaymentResponse.orders_meta.ppl}}
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--w-35--->

      <div class="w-60">

        <div class="voucher-code text-center" *ngIf="orderPaymentResponse.product.voucher_code != ''">
          <h4>Your Unique Voucher Code</h4>
          <div class="code" *ngFor="let code of orderPaymentResponse.product.voucher_code">
            {{code.voucher_code}}</div>
          <p>Show this code to our partner(s) and redeem your experience seamlessly</p>
        </div>
        <!--voucher-code--->

        <div class="order-summery uk-flex">
          <div class="order-summery-card rightangle">
            <h5>Order Summary</h5>
            <div class="uk-flex order-price">
              <p class="w-50">{{orderPaymentResponse.product.quantity}} x
                {{orderPaymentResponse.product.product_title}} for
                {{orderPaymentResponse.orders_meta.ppl}} people
              </p>
              <h4 class="w-50"><i class="fa fa-rupee"></i>{{orderPaymentResponse.product.price}}</h4>
            </div>

            <div class="order-table uk-flex" *ngIf="orderPaymentResponse.order.ticketxpress_voucher_number !=''">
              <div class="w-50">
                <p>Voucher Code</p>
              </div>
              <div class="w-50">
                <h6>{{orderPaymentResponse.order.ticketxpress_voucher_number}}</h6>
              </div>
            </div>
            <div class="order-table uk-flex" *ngIf="orderPaymentResponse.order.ticketxpress_voucher_amount > 0">
              <div class="w-50">
                <p>Voucher Amount</p>
              </div>
              <div class="w-50">
                <h6><i class="fa fa-rupee"></i> {{orderPaymentResponse.order.ticketxpress_voucher_amount}}</h6>
              </div>
            </div>
            <div class="order-table uk-flex">
              <div class="w-50">
                <p>Paid On</p>
              </div>
              <div class="w-50">
                <h6>{{orderPaymentResponse.order.order_date}}</h6>
              </div>
            </div>
            <div class="order-table uk-flex" *ngIf="orderPaymentResponse.order.payment_method !=''">
              <div class="w-50">
                <p>Payment Method</p>
              </div>
              <div class="w-50">
                <h6>{{orderPaymentResponse.order.payment_method}}</h6>
              </div>
            </div>
          </div>
          <div class="order-details text-center">
            <h5>Order ID : {{orderPaymentResponse.order.order_id}}</h5>
            <p>Total (INR)</p>
            <h4><i class="fa fa-rupee"></i>
              {{orderPaymentResponse.order.order_total_price - orderPaymentResponse.order.ticketxpress_voucher_amount}}
            </h4>
          </div>
        </div>

      </div>
      <!--65--->

    </div>

    <div class="need-help uk-flex uk-flex-middle uk-flex-between mt-2">
      <div class="info">
        <h4>Need our Help?</h4>
        <p>Having troubles or questions about this experience? Reach out to us!</p>
      </div>
      <div class="number">
        <a href="tel:18002667666"> <img src="assets/images/icons/call-4.png" alt=""> 1800 266 7666</a>
      </div>
    </div>

    <div class="btn-box mt-3  mb-4">
      <a href="" class="back-btn">GO BACk TO HOME PAGE</a>
    </div>

  </li>
</div>

<section class="notfound-page-wrp" *ngIf="!product">
  <div class="container">
    <div class="notfound-page-card">
      <img src="assets/images/cart-empty.png" alt="">
      <p></p>
      <a [routerLink]="['/']" class="btn-default">Back to Home</a>
    </div>
  </div>
</section>

<app-footer></app-footer>
